// (function() {
//   const seen = new Set();
//   const origDispatch = EventTarget.prototype.dispatchEvent;

//   EventTarget.prototype.dispatchEvent = function(event) {
//     if (!seen.has(event.type)) {
//       seen.add(event.type);
//       console.log("%c🔥 Event fired:", "color: orange", event.type, "on", this);
//     }
//     return origDispatch.call(this, event);
//   };

//   console.log("%cGlobal event logger active (will log unique events only)", "color: lightgreen");
// })();

//   console.log("%cEvent logger active... Ignoring common events", "color: lightgreen");
// })();

// (function() {
//   const reloadEvents = [
//     "event-subscribers:setup",
//     "update-event-listeners",
//     "wk:state:refetch",
//     "wk:state:action",
//     "listbox:change"
//   ];

//   reloadEvents.forEach(ev => {
//     window.addEventListener(ev, () => {
//       console.log("%c[window] Yotpo refresh after " + ev, "color: orange");
//     });

//     document.addEventListener(ev, () => {
//       console.log("%c[document] Yotpo refresh after " + ev, "color: lightblue");
//     });
//   });
// })();

(function() {
  function refreshYotpo(evName) {
    console.log("⏳ Trying Yotpo refresh after:", evName);

    setTimeout(() => {
      try {
        if (window.yotpoWidgetsContainer?.initWidgets) {
          //console.log("✅ Yotpo initWidgets() called");
          window.yotpoWidgetsContainer.initWidgets();
        } else if (window.yotpo?.refreshWidgets) {
          //console.log("✅ Yotpo refreshWidgets() called");
          window.yotpo.refreshWidgets();
        } else {
          console.log("❌ Yotpo API not available yet");
        }
      } catch (err) {
        console.error("⚠️ Error refreshing Yotpo:", err);
      }
    }, 0); // adjust delay if needed
  }

  // 🎯 Attach listener only to theme:loading:end
  document.addEventListener("theme:loading:end", () => refreshYotpo("theme:loading:end"));
})();
